<h1 class="_primary cell shrink"[i18nKey]="'ranking.title'"></h1>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div *ngIf="showRankingForm && rankingMenuDisabled != undefined" class="cell shrink grid-x align-justify blockContent questionBlock">
    <div class="cell shrink grid-x grid-margin-x align-middle">
        <span class="cell shrink questionBlock-question"[i18nKey]="'ranking.display.question'"></span>
        <div (click)="toggleRankingMenuDisabled(false)"
             [class._active]="!rankingMenuDisabled" class="cell shrink questionBlock-choice"[i18nKey]="'common.yes'"></div>
        <div (click)="toggleRankingMenuDisabled(true)"
             [class._active]="rankingMenuDisabled" class="cell shrink questionBlock-choice"[i18nKey]="'common.no'"></div>
    </div>
    <div class="cell shrink">
        <button (click)="updateRankingMenuDisabled()" class="button _small"[i18nKey]="'common.action.save'"></button>
    </div>
</div>

<kiwi-spacer [size]="8"></kiwi-spacer>

<div class="cell auto grid-y">
    <div class="cell auto cell-block-y blockContent" *ngIf="ranking">
        <h2 class="_sansSerif _primary"[i18nKey]="'ranking.total.rating'"></h2>

        <kiwi-spacer [size]="8"></kiwi-spacer>

        <ng-container *ngIf="ranking.length > 0">
            <div class="grid-x align-center rankingTop">
                <div class="cell shrink rankingTop-item _first">
                    <span class="rankingTop-item-name">{{ranking[0].teamName}}</span>
                    <span class="rankingTop-item-number"><span [i18nKey]="'area.competition.team.number'"></span> {{ranking[0].teamNumber}}</span>
                    <span class="rankingTop-item-rank"[i18nKey]="'area.competition.first'"></span>
                </div>
                <div class="cell shrink rankingTop-item _second" *ngIf="ranking.length > 2">
                    <span class="rankingTop-item-name">{{ranking[1].teamName}}</span>
                    <span class="rankingTop-item-number"><span [i18nKey]="'area.competition.team.number'"></span> {{ranking[1].teamNumber}}</span>
                    <span class="rankingTop-item-rank"[i18nKey]="'area.competition.second'"></span>
                </div>
                <div class="cell shrink rankingTop-item _third" *ngIf="ranking.length > 2">
                    <span class="rankingTop-item-name">{{ranking[2].teamName}}</span>
                    <span class="rankingTop-item-number"><span [i18nKey]="'area.competition.team.number'"></span> {{ranking[2].teamNumber}}</span>
                    <span class="rankingTop-item-rank"[i18nKey]="'area.competition.third'"></span>
                </div>
            </div>

            <kiwi-spacer [size]="16"></kiwi-spacer>

            <table class="_tableColor">
                <thead>
                <tr class="_titlePartTable">
                    <th [i18nKey]="'ranking.team.number'"></th>
                    <th [i18nKey]="'ranking.team.name'"></th>
                    <th [i18nKey]="'ranking.team.rank'"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let rankedTeam of ranking">
                    <td>{{rankedTeam.teamNumber}}</td>
                    <td>{{rankedTeam.teamName}}</td>
                    <td>{{rankedTeam.rank}}</td>
                </tr>
                </tbody>
            </table>
        </ng-container>

        <div class="cell auto grid-y align-center align-middle cell-block-y blockContent"
             *ngIf="ranking.length === 0">
            <div class="cell shrink rankingUnavailable-img"></div>
            <span class="cell shrink rankingUnavailable-text"[i18nKey]="'ranking.unavailable'"></span>
        </div>
    </div>
</div>
